import { render, staticRenderFns } from "./ModalBackground.vue?vue&type=template&id=b8f639f2&"
import script from "./ModalBackground.vue?vue&type=script&lang=js&"
export * from "./ModalBackground.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports